export let prioritySortCalloutHeading = "mSCYUc";
export let prioritySortCalloutDescription = "IYVgXb";
export let prioritySortCalloutSecondaryButtonText = "$OJ1D";
export let prioritySortCalloutTryNowText = "C3qTsb";
export default {prioritySortCalloutHeading,prioritySortCalloutDescription,prioritySortCalloutSecondaryButtonText,prioritySortCalloutTryNowText};